import { Box, Flex, Image, Input, InputGroup, InputLeftElement, Link, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useMoralisQuery } from 'react-moralis';
import { SearchIcon } from 'src/utils/icons/search';
import { Color } from 'src/theme/color';
import { useNavigate } from 'react-router-dom';

export const KeyOpener = () => {
	const [search, setSearch] = useState('');
	const [searchResults, setSearchResults] = useState([]);

	const navigate = useNavigate();

	const {
		data: queryData,
		isLoading: isQueryDataLoading,
		isFetching: isQueryDataFetching,
	} = useMoralisQuery('Games', query => query.equalTo('listed', true), [search]);

	const handleSearch = (e: any) => {
		setSearch(e.target.value);
		if (e.target.value.length > 2) {
			const data = (queryData as any).map((entity: any) => entity.attributes);
			const results = data.filter(
				(datum: any) =>
					(datum.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
						datum.address.includes(e.target.value)) &&
					datum?.platforms?.includes('software-key')
			);
			console.log('results', results);
			setSearchResults(results);
		} else setSearchResults([]);
	};

	return (
		<Flex
			flexDir="column"
			gap="24px"
			align="center"
			w="100%"
			maxWidth={{ base: '80%', hashup: '1168px', xl: '1240px' }}
			py="48px"
		>
			<Box
				as="span"
				fontSize="48px"
				fontWeight="700"
				_hover={{ textDecoration: 'none' }}
			>
				Open your&nbsp;
				<Text
					color="#ff3f3f"
					as="span"
				>
					key
				</Text>
				.
			</Box>
			<InputGroup position="relative">
				<InputLeftElement>
					<SearchIcon />
				</InputLeftElement>
				<Input
					placeholder="Search for product to open"
					value={search}
					onChange={handleSearch}
					_focus={{ outline: 'none !important', border: '1px solid white !important' }}
				/>
				{searchResults.length > 0 && (
					<Flex
						position="absolute"
						top="40px"
						left="0px"
						w="100%"
						bg={Color.BACKGROUND_ACCENT}
						borderRadius="0 0 8px 8px"
						p="16px 24px"
						flexDir="column"
						gap="16px"
						zIndex="1000"
						maxH="200px"
						overflowY="auto"
					>
						{searchResults.map((product: any) => (
							<Link
								alignItems="center"
								w="100%"
								gap="8px"
								fontSize="14px"
								cursor="pointer"
								target="_blank"
								href={`https://www.hashup.it/keys/${product?.address}`}
								_hover={{ textDecoration: 'none' }}
								display="flex"
							>
								<Image
									src={product?.media?.banner}
									maxW="48px"
									maxH="48px"
									minW="48px"
									minH="48px"
									borderRadius="8px"
									objectPosition="center"
									objectFit="cover"
								/>
								<Flex
									flexDir="column"
									gap="2px"
								>
									<Text fontWeight="600">{product?.name}</Text>
									<Text
										fontWeight="300"
										opacity="0.7"
										fontSize="12px"
									>
										{product?.address?.slice(0, 7) + '...' + product?.address?.slice(-7)}
									</Text>
								</Flex>
							</Link>
						))}
					</Flex>
				)}
			</InputGroup>
		</Flex>
	);
};
